<script>
  export default{
    name : 'BlogDefaultIcon'
  }
</script>
<template>
  <g>
    <rect width="558" height="332" fill="#FFBEAB"/>
    <path d="M273.649 122.701H235.033C232.107 122.701 229.301 123.864 227.232 125.933C225.162 128.002 224 130.808 224 133.734V210.966C224 213.892 225.162 216.698 227.232 218.767C229.301 220.836 232.107 221.999 235.033 221.999H312.265C315.191 221.999 317.997 220.836 320.066 218.767C322.135 216.698 323.298 213.892 323.298 210.966V172.35" stroke="#FF4814" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M315.021 114.428C317.216 112.233 320.192 111 323.296 111C326.4 111 329.376 112.233 331.571 114.428C333.766 116.622 334.998 119.599 334.998 122.702C334.998 125.806 333.766 128.783 331.571 130.977L279.164 183.384L257.098 188.901L262.614 166.835L315.021 114.428Z" stroke="#FF4814" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</template>